<template>
  <q-btn
    dense
    size="0.675rem"
    flat
    round
    :color="color"
    icon="fal fa-question-circle"
    @click="$router.absUrl(page.url)"
  >
    <LmTooltip>
      {{ page.tooltip }}
    </LmTooltip>
  </q-btn>
</template>

<script>
export default {
  props: {
    page: {
      type: Object,
      required: true
    },

    color: {
      type: String,
      default: 'tertiary'
    }
  }
}
</script>
